import ReactTooltip from 'react-tooltip';

import TenantConfig from '../../../config';
import { isApplicationWIP } from '../../../constants/status';
import { isInitialSubmit, isPrimaryApplicant } from '../../../helpers/applicationHelp';

export const SetFeatures = ({
  appData,
  setConsentFeatures,
  setFeatures,
  setProperties,
  setSections,
  setIsMainApplicant,
  setIsInitialSubmission,
}) => {
  const filteredFeatures =
    appData?.applicationFeatures?.filter(
      (feature) => feature?.name?.toLowerCase().includes('consent') && feature?.section === 'review'
    ) || [];
  setConsentFeatures(filteredFeatures);
  let lFeatures;
  if (isApplicationWIP(appData.status)) {
    lFeatures = appData?.applicationFeatures;
  } else {
    lFeatures = appData?.applicationFeatures?.filter((feature) => {
      return (
        feature.phase === appData.phase &&
        appData.sectionSequence.includes(feature.section) &&
        (feature.itemType !== 'FileProperty' ||
          (feature.itemType === 'FileProperty' &&
            feature.value.filter(
              (file) =>
                (file.status === 'REQUESTED' || file.status === 'DECLINED') &&
                !file.fileType.includes('bankVerificationStatement')
            ).length > 0))
      );
    });
  }
  setFeatures(lFeatures);
  const lIsMainApplicant = isPrimaryApplicant(appData);
  setIsMainApplicant(lIsMainApplicant);
  setIsInitialSubmission(isInitialSubmit(appData));
  let filteredProps;
  if (isApplicationWIP(appData.status)) {
    filteredProps = appData.propertySequence;
  } else {
    filteredProps = lFeatures?.map((feature) => {
      if (feature.name) return feature.name;
    });
  }
  setProperties(filteredProps);

  const filteredSections = [
    ...new Set(
      lFeatures?.map((feature) => {
        if (feature.section) return feature.section;
      })
    ),
  ];

  const filteredArray2 = !filteredSections
    ? []
    : filteredSections.filter((value) => appData.sectionSequence.includes(value));

  setSections(
    TenantConfig?.stepper.showApplyStep
      ? [...filteredArray2, appData.phase === 'PRE_SUBMISSION' ? 'Apply' : 'Review']
      : filteredArray2
  );
  ReactTooltip.rebuild();
  window.scrollTo(0, 0);
};
